import "./Card.scss";

export default function Card({
  title,
  actions,
  children,
  className = "",
  accent = false,
}) {
  return (
    <div className={`ui-card ${accent ? "accent" : ""} ${className}`}>
      {(title || actions) && (
        <div className="ui-card-header">
          {title && <h3 className="ui-card-title">{title}</h3>}
          {actions && <div className="ui-card-actions">{actions}</div>}
        </div>
      )}
      <div className="ui-card-body">{children}</div>
    </div>
  );
}
